import clsx from "clsx";
import { FC } from "react";
import styles from "./LinkCopiedBadge.module.scss";

export type Props = {
  show: boolean;
  className?: string;
  isRightAligned?: boolean;
};

const LinkCopiedBadge: FC<Props> = ({ show, className, isRightAligned }) => {
  if (!show) return null;

  const message = "Link copied";

  return (
    <span
      className={clsx(styles.badge, isRightAligned && styles.right, className)}
    >
      <span className={styles.text}>{message}</span>
    </span>
  );
};

export default LinkCopiedBadge;
